// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c19e5cc3","453":"c4ba4f18","732":"138576bd","977":"0cf36f1a"}[chunkId] + ".chunk.js";
};